import { AiFillLinkedin, AiFillGithub, AiFillInstagram } from 'react-icons/ai';
import { FaAngellist } from 'react-icons/fa';
import { BsTelegram, BsBoxArrowUpRight } from 'react-icons/bs';

function Footer() {
  return (

    <div className="border-t border-secondary/20 dark:border-secondaryDarck/20 bg-transparent backdrop-blur-sm flex sm:flex-row flex-col justify-around items-center h-24 sm:h-20 gap-4 mt-10">

      <a href="../works/01Mohammed AlFuhidy Resume - (fr).pdf" target="_blank" rel="noreferrer">
        <span className="transition-all ease-out duration-500 flex text-base font-medium text-text dark:text-textDarck items-center gap-2 cursor-pointer sm:pt-0 pt-4 hover:text-primary dark:hover:text-primaryDarck">
          Get my Resume
          <BsBoxArrowUpRight className="text-text text-base dark:text-accentDarck " />
        </span>
      </a>

      <div className=" text-lg  sm:text-xl flex gap-4  text-text  transition-all ease-out duration-500 sm:pb-0 pb-4 ">
        <a href="https://www.linkedin.com/in/mo-fuhidy/" target="_blank" className="dark:text-accentDarck dark:hover:text-textDarck hover:transition-opacity hover:duration-500 hover:text-accent" rel="noreferrer">
          <AiFillLinkedin />
        </a>
        <a href="https://github.com/Mofuhidy" target="_blank" className="dark:text-accentDarck dark:hover:text-textDarck hover:transition-opacity hover:duration-500 hover:text-accent" rel="noreferrer">
          <AiFillGithub />
        </a>

        <a href="https://wellfound.com/u/mo-fuhidy" target="_blank" className="dark:text-accentDarck dark:hover:text-textDarck hover:transition-opacity hover:duration-500 hover:text-accent" rel="noreferrer">
          <FaAngellist />
        </a>

        <a href="https://www.t.me/mofuhidy" target="_blank" className="dark:text-accentDarck dark:hover:text-textDarck hover:transition-opacity hover:duration-500 hover:text-accent" rel="noreferrer">
          <BsTelegram />
        </a>

        <a href="https://www.instagram.com/mofuhidy/" target="_blank" className="dark:text-accentDarck dark:hover:text-textDarck hover:transition-opacity hover:duration-500 hover:text-accent" rel="noreferrer">
          <AiFillInstagram />
        </a>
      </div>
    </div>

  );
}
export default Footer;
